<template>
  <div style="display:flex;width:100%">
    <div v-if="$store.getters.languageQuestionAdmin === 'fr'">
      {{ question.entitled }}
    </div>
    <div v-if="$store.getters.languageQuestionAdmin === 'en'">
      {{ question.entitled_en }}
    </div>
    <div v-if="$store.getters.languageQuestionAdmin === 'es'">
      {{ question.entitled_es }}
    </div>
    <div v-if="$store.getters.languageQuestionAdmin === 'de'">
      {{ question.entitled_de }}
    </div>
    <ButtonFoldingQuestion
        style=" margin-left: auto;"
        :AllFolding="AllFolding"
        :indexQuestion="indexQuestion"
        :indexSection="indexSection"
      />
  </div>
</template>

<script>
import ButtonFoldingQuestion from '@/components/question/components/ButtonFoldingQuestion'
export default {
  name: 'TitleQuestionAllFolding',
  props: ['AllFolding', 'question', 'indexQuestion', 'indexSection'],
  components: {
    ButtonFoldingQuestion
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/question/components/TitleQuestionAllFolding.vue